export default "__VITE_ASSET__CAJE8kD6__"